import { Button } from '@components/button';
import { createForm } from '@components/form';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

import { SignetToken, useConnectSignet } from './api';

const Form = createForm<SignetToken>();

export const SignetConnectModal = ({ closeModal, isEdit }: ModalProps<{ isEdit: boolean }>) => {
  const { t } = useStore();
  const submit = useConnectSignet(isEdit, { onSuccess: closeModal });

  return (
    <Stack space={6}>
      <Text font="heading2" text={t('integrations.signet.settings.connect.modal.header')} />
      <Text font="regular16" text={t('integrations.signet.settings.connect.modal.description')} />
      <Form onSubmit={(values) => submit.mutateAsync(values)}>
        <Form.TextField
          label={t('integrations.signet.settings.connect.modal.username.label')}
          validators={['required']}
          id="username"
        />
        <Form.TextField
          label={t('integrations.signet.settings.connect.modal.password.label')}
          validators={['required']}
          id="password"
        />
        <Form.TextField
          label={t('integrations.signet.settings.connect.modal.certificatepassword.label')}
          validators={['required']}
          id="certificatePassword"
        />
        <Form.FileField
          id="certificate"
          label={t('integrations.signet.settings.connect.modal.certificate.label')}
          accept=".p12"
          validators={['required']}
        />
        <Form.Actions>
          <Button
            variant="secondary"
            text={t('integrations.signet.settings.connect.modal.cancel')}
            onClick={closeModal}
          />
          <Form.Submit text={t('integrations.signet.settings.connect.modal.connect')} />
        </Form.Actions>
      </Form>
    </Stack>
  );
};
